import { Link } from 'react-router-dom';
import { Compass } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { EmptyState } from '@/components/common';

export function NotFoundPage(): JSX.Element {
  return (
    <EmptyState
      icon={Compass}
      title="Страницата не съществува"
      description="Линкът може да е стар или сгрешен."
      action={
        <Button asChild>
          <Link to="/">Към началото</Link>
        </Button>
      }
    />
  );
}
